import React from "react";
import CreatableSelect from "react-select/creatable";
import { ErrorCampo } from "../general/Seccion";

/**
 * Las dos presentaciones del producto: la unidad base (valor 1) y el empaque
 * opcional con su cantidad en paquete. Lo usan Crear y Editar; el estado vive
 * en cada uno.
 */
const Presentaciones = ({
	unidades = [],
	unidad,
	empaque,
	cantidadEmpaque,
	onChangeUnidad,
	onChangeEmpaque,
	onChangeCantidad,
	onCreateUnidad,
	onCreateEmpaque,
	isLoading,
	disabled,
	conEmpaque = true,
	errors = {},
}) => (
	<div className="form-row">
		<div className={`form-group col-12 ${conEmpaque ? "col-md-4" : ""}`}>
			<label className="label form-control-label">
				Unidad: <small className="text-muted">(valor 1)</small>
			</label>
			<input type="hidden" name="unidad_id" value={unidad?.id ?? ""} />
			<CreatableSelect
				options={unidades}
				name="unidad"
				isClearable
				isDisabled={isLoading || disabled}
				isLoading={isLoading}
				menuPlacement="auto"
				onChange={onChangeUnidad}
				value={unidad || null}
				onCreateOption={onCreateUnidad}
			/>
			<ErrorCampo errors={errors} campo="unidad" />
			<ErrorCampo errors={errors} campo="unidad_id" />
		</div>
		{conEmpaque && (
			<>
				<div className="form-group col-7 col-md-4">
					<label className="label form-control-label">Empaque:</label>
					<input type="hidden" name="unidad_empaque_id" value={empaque?.id ?? ""} />
					<CreatableSelect
						options={unidades.filter((u) => u.value !== unidad?.value)}
						isClearable
						isDisabled={isLoading || disabled}
						isLoading={isLoading}
						menuPlacement="auto"
						placeholder="Sin empaque"
						onChange={onChangeEmpaque}
						value={empaque}
						onCreateOption={onCreateEmpaque}
					/>
					<ErrorCampo errors={errors} campo="unidad_empaque_id" />
				</div>
				<div className="form-group col-5 col-md-4">
					<label className="label form-control-label">Cantidad en paquete:</label>
					<input
						type="number"
						min="2"
						step="any"
						inputMode="decimal"
						className="text-input form-control"
						name="cantidad_empaque"
						value={empaque ? cantidadEmpaque : ""}
						disabled={!empaque || disabled}
						onChange={(e) => onChangeCantidad(e.target.value)}
					/>
					<ErrorCampo errors={errors} campo="cantidad_empaque" />
				</div>
			</>
		)}
	</div>
);

export default Presentaciones;
